import { ICustomIdFieldPopulateFieldItem } from './custom-id-input-field-populates-item.model';
import { IDateTimePickerSetting } from './form-builder-types-configurations.model';
import {
  EAvailableConditionalValidations,
  IConditionalValidationConfig,
  IFormFieldsConditionRule,
  IUtilValidationConfig,
} from './form-fields-formly-conditional-validation.model';

export interface IFormFieldsValidationModel {
  configuredFieldRootModelPath?: string | null; // path to access the form root model from the configured field
  configuredFieldRefPath?: string | null; // path to access the configured field from the root form.
  required?: boolean;
  min?: number;
  max?: number;
  minLength?: number;
  maxLength?: number;
  uniqueField?: string[];
  uniqueFieldMessage?: string;
  patternValidation?: IPatternValidation;
  populates?: ICustomIdFieldPopulateFieldItem[];
  validationMessages?: Record<string, string>;
  fileSize?: IFileSizeValidationConfig;
  fileFormats?: Record<string, boolean> | undefined;
  invalidTIN?: string;
  idConditions?: IIdConditionsModel;
  tableValidation?: {
    required?: boolean;
    minSelections?: number;
    maxSelections?: number;
    selectionMessage?: string;
  };
  // Date picker specific validation properties
  allowedDaysOfTheWeek?: number[];
  addRemoveTimeMinDate?: string;
  addRemoveTimeMaxDate?: string;
  minDate?: any;
  maxDate?: any;
  eventCode?: string;
  eventDatesMaxSize?: string;
  minSelection?: number;
  maxSelection?: number;

  // conditional Validaitions
  conditionalValidations?: IConditionalValidations;

  // util Validaitions
  utilValidations?: IUtilValidationConfig[];

  // New structure validations
  validations?: {
    [key: string]: {
      logics: IValidationLogic[];
    };
  };
}

export interface IValidationLogic {
  conditions?: IFormFieldsConditionRule[];
  errorMessage?: string;
  errorMessages?: Record<string, string>;
  [key: string]: any;
}

export interface IPatternValidation {
  patternType: EFieldValidationPatternConfigOptions;
  customPattern: string;
}

export interface IConditionalValidations {
  required: IConditionalValidationConfig;
  minLength: IConditionalValidationConfig[];
  maxLength: IConditionalValidationConfig[];
  patternValidation: IConditionalValidationConfig[];
}

export interface IIdConditionsModel {
  ageLimit?: IIdConditionsAgeLimit;
  sex?: IIdConditionsKeyAllowedValues;
  civilStatus?: IIdConditionsKeyAllowedValues;
  citizenStatus?: IIdConditionsKeyAllowedValues;
}

export interface IIdConditionsAgeLimit {
  key?: string;
  minimumAge?: number;
  maximumAge?: number;
}

export interface IIdConditionsKeyAllowedValues {
  key?: string;
  allowedValues?: string[];
}

export enum EFieldValidationPatternConfigOptions {
  EMAIL = 'Email',
  LETTERS_A_TO_Z = 'LettersAToZ',
  NUMBERS_0_TO_9 = 'Numbers0To9',
  SYMBOLS = 'Symbols',
  LETTERS_AND_NUMBERS = 'LettersAndNumbers',
  LETTERS_AND_NUMBERS_AND_SYMBOLS = 'LettersAndNumbersAndSymbols',
  NO_EMPTY_SPACES_ONLY = 'NoEmptySpacesOnly',
  CUSTOM = 'Custom',
}

export interface IFileSizeValidationConfig {
  minimumUploadSize?: number;
  maximumUploadSize?: number;
}

/*
  Interface for all available validations
*/
export interface IAvailableValidations {
  required?: boolean;
  min?: number;
  max?: number;
  minLength?: number;
  maxLength?: number;
  uniqueField?: string[];
  uniqueFieldMessage?: string;
  patternValidation?: IPatternValidation;
  populates?: ICustomIdFieldPopulateFieldItem[];
  fileSize?: IFileSizeValidationConfig;
  fileFormats?: Record<string, boolean | undefined>;
  invalidTIN?: string;
  idConditions?: IIdConditionsModel;
  tableValidation?: {
    required?: boolean;
    minSelection?: number;
    maxSelection?: number;
    selectionMessage?: string;
  };

  // Date picker specific validation properties
  eventCode?: string;
  eventDatesMaxSize?: string;
  minDateConfig?: any;
  maxDateConfig?: any;
  allowedDaysOfTheWeek?: Record<string, boolean>;

  minDate?: any;
  maxDate?: any;
  minSelection?: number;
  maxSelection?: number;

  dateTimePickerSetting?: IDateTimePickerSetting;
  invalidInput?: boolean;
  invalidId?: boolean;
  invalidNumber?: boolean;
  invalidNumberFormat?: boolean;
  invalidAppNo?: boolean;
  invalidDate?: boolean;
  unavailableSlots?: boolean;
  dayOfWeekIsNotAllowed?: boolean;
  dateAndTimeValuesRequired?: boolean;
  invalidTimeValue?: boolean;
  invalidDateTimeFormat?: boolean;
}

export type TAvailableValidations = keyof IAvailableValidations;
export type TAvailableConditionalValidations =
  keyof typeof EAvailableConditionalValidations;
